import api from "./api";

export interface SearchResultItem {
    id: number;
    name: string;
    type: "customer" | "employee" | "service" | "product" | "booking";
    email?: string | null;
    mobile?: string | null;
    info?: string;
    category?: string;
    price?: string;
    duration?: string;
    stock?: number;
    date?: string;
    user_image_url?: string;
    mobile_with_code?: string;
    formatted_mobile?: string;
}

export type GlobalSearchResponse = SearchResultItem[];

export const globalSearch = async (query: string): Promise<GlobalSearchResponse> => {
    try {
        const response = await api.get(`/admin/global/search/${query}`, {
            headers: {
                Accept: "application/json",
            },
        });
        return response.data;
    } catch (err: any) {
        console.error("Global search failed:", err);
        throw err;
    }
};
